import { render, staticRenderFns } from "./Export.vue?vue&type=template&id=04a88e0c&scoped=true&"
import script from "./Export.vue?vue&type=script&lang=ts&"
export * from "./Export.vue?vue&type=script&lang=ts&"
import style0 from "./Export.vue?vue&type=style&index=0&id=04a88e0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a88e0c",
  null
  
)

export default component.exports